export default "__VITE_ASSET__BsQkvTyY__"